module.exports = __webpack_public_path__ + "static/media/radio-on.fd06a7c0.svg";